import { render, staticRenderFns } from "./CancerSymposiumPage.vue?vue&type=template&id=3b6e648f&scoped=true"
var script = {}
import style0 from "./CancerSymposiumPage.vue?vue&type=style&index=0&id=3b6e648f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b6e648f",
  null
  
)

export default component.exports